export default __webpack_public_path__ + "static/media/arrowDownDropDown.275b44df.svg";